import { Briefcase } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";

const TARGETS = [
  "Pensiuni",
  "Hoteluri",
  "Apartamente în regim hotelier",
  "Restaurante",
  "Magazine",
  "Birouri",
  "Proprietăți comerciale",
  "Administratori de proprietăți",
];

const SERVICES = [
  "Intervenții rapide",
  "Mentenanță",
  "Reparații programate",
  "Renovări",
  "Echipe de specialiști",
];

export default function BusinessBand() {
  const { openQuote } = useSite();
  return (
    <section className="bg-ink-950 py-14 sm:py-20" data-testid="business-section">
      <div className="container-brox">
        <Reveal>
          <div className="border border-white/10 bg-ink-900 p-6 sm:p-10">
            <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
              <div>
                <p className="eyebrow mb-3 flex items-center gap-2">
                  <Briefcase className="h-4 w-4" />
                  BROX PENTRU AFACEREA TA
                </p>
                <h2 className="display-title text-3xl sm:text-4xl" data-testid="business-title">
                  Un singur contact pentru<br />toate lucrările firmei tale.
                </h2>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base" data-testid="business-copy">
                  În loc să cauți un meseriaș diferit de fiecare dată când ceva se strică, ai un singur punct
                  de contact pentru întreaga proprietate: intervenții rapide, mentenanță, reparații programate,
                  renovări și echipe de specialiști.
                </p>
                <div className="mt-5 flex flex-wrap gap-1.5" data-testid="business-services">
                  {SERVICES.map((s) => (
                    <span key={s} className="border border-copper/30 bg-copper/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-copper">
                      {s}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex flex-col justify-center border-t border-white/10 pt-6 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0">
                <p className="label-brox">Lucrăm cu</p>
                <div className="flex flex-wrap gap-1.5" data-testid="business-targets">
                  {TARGETS.map((t) => (
                    <span key={t} className="border border-white/10 bg-ink-950 px-3 py-1.5 text-xs text-paper/75">
                      {t}
                    </span>
                  ))}
                </div>
                <button
                  onClick={() => openQuote({ request_type: "B2B_MAINTENANCE", source: "b2b" })}
                  className="btn-primary copper-sheen mt-8 w-full sm:w-auto"
                  data-testid="business-cta"
                >
                  SOLICITĂ O DISCUȚIE
                </button>
                <p className="mt-4 text-xs text-muted-foreground">
                  Ne descrii proprietatea și nevoile tale — îți propunem un plan de colaborare.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
